import type { FaireProductEntity } from "../../entity_types/product";

export const p_ucy6vyhj6v: FaireProductEntity = {
  token: "p_ucy6vyhj6v",
  type: "product",
  name: "Drawstring Pouches -Silk",
  brandToken: "b_592svxunwb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2c04fa0091cd14c65c102e98383c2d9257799f1649a1a0e243832e3e15358e5f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/10fb8ce0b488a2221c4f78c81ce1812cd64924c2ac7e06670036717f7675d11d.jpeg",
    "https://cdn.faire.com/fastly/8052ccba466be93e8662b5643d1b6778192b11349eddd84b9f2f3089f43ba903.jpeg",
    "https://cdn.faire.com/fastly/72248bc5903a4cc711f66fdfb55746c2950c2dd55893b5cf8228c71621174eb5.jpeg",
    "https://cdn.faire.com/fastly/60477bbfd060ceb993353a83e42f6d8b030599a08b61b2da2ec2cd03a40763b5.jpeg",
    "https://cdn.faire.com/fastly/273792a15c8a40545edb1709d6f61014f52568f69dcc1bc2417033e04d5674c3.jpeg",
    "https://cdn.faire.com/fastly/4a72b7a0c16b6eb2aaf1f3f4e9d2e5662521f872647cce79b8e27203d2de5890.jpeg",
  ],
  priceDollars: 2.09,
  description:
    "These pouches are handcrafted in Nepal by our Fair Trade partners from  100% silk saris, up-cycling at its best! Pulling the alternate strings draws the pouch open and closed. Pouches come in assorted colors - if you are buying more than one we will always ship you a selection. Small size (our most popular) is perfect for holding a bracelet, or anything about the size of a credit card. Medium is great for holding a large bracelet, or something about the size of a pack of cards and the large size is ideal for holding a few necklaces, or something about the size of a large deck of tarot cards ",
  tags: [],
  msrpDollars: 4.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:38.581Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
